export default __webpack_public_path__ + "static/media/deferred-courses.ce975fd9.svg";